import {
  EDIT_CONTACT,
  GET_ALL_COMPANIES,
  GET_ALL_COMPANIES_IDS,
  GET_ALL_CONTACTS_IDS,
  GET_COMPANY_DETAILS,
  GET_CONTACT_DETAILS,
  GET_CONTACT_LIST,
  GET_CONTACT_LIST_ALL,
  LIST_COMPANY_CONTACTS,
  SEARCH_CONTACT,
} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_COMPANIES: {
      return {
        ...state,
        getCompaniesData: action.payload,
      }
    }

    case GET_ALL_COMPANIES_IDS:
      return {...state, companiesIdsList: action.payload}

    case GET_COMPANY_DETAILS:
      return {
        ...state,
        getCompanyDetails: action.payload,
      }
    case GET_CONTACT_LIST: {
      return {
        ...state,
        getContactListData: action.payload,
      }
    }

    case GET_CONTACT_LIST_ALL: {
      return {
        ...state,
        getContactListAllData: action.payload,
      }
    }

    case GET_ALL_CONTACTS_IDS:
      return {...state, contactsIdsList: action.payload}

    case GET_CONTACT_DETAILS:
      return {
        ...state,
        getContactDetails: action.payload,
      }

    case SEARCH_CONTACT:
      return {
        ...state,
        getContactListData: action.payload,
      }

    case 'UPDATE_SEARCH_FILTER_LIST':
      return {
        ...state,
        getContactListData: action.payload,
      }

    case EDIT_CONTACT: {
      const list = state.getContactListData ? [...state.getContactListData.contacts] : []
      const updatedIndex = list.findIndex(contact => contact.id === action.payload.id)

      if (updatedIndex !== -1) list.splice(updatedIndex, 1, action.payload)

      return {
        ...state,
        updateContactProfileMsg: action.status || action.error,
        getContactDetails: {...state.getContactDetails, ...action.payload},
        getContactListData: {
          ...state.getContactListData,
          contacts: list,
        },
      }
    }

    case LIST_COMPANY_CONTACTS:
      return {
        ...state,
        companyList: action.payload,
      }

    default:
      return state
  }
}
